"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhoneFieldLogic = void 0;
var phone_fieldtype_1 = require("./phone.fieldtype");
Object.defineProperty(exports, "PhoneFieldLogic", { enumerable: true, get: function () { return phone_fieldtype_1.PhoneFieldLogic; } });
